import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  const scrollToOffers = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offersSection = document.getElementById('comprar');
    if (offersSection) {
      const headerHeight = 56;
      const isMobile = window.innerWidth < 768;
      const offset = isMobile ? -220 : -180;
      const elementPosition = offersSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const scrollToWhatIncludes = (e: React.MouseEvent) => {
    e.preventDefault();
    const includesSection = document.getElementById('que-incluye');
    if (includesSection) {
      const headerHeight = 56;
      const offset = 20;
      const elementPosition = includesSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <div className="relative min-h-[100vh] flex items-center justify-center overflow-hidden pt-28 pb-20 bg-gradient-to-br from-gray-900 via-gray-950 to-pink-950" data-id="element-110">
      {/* Decorative gradient orbs — no images, pure CSS */}
      <div className="absolute inset-0 z-0 overflow-hidden" aria-hidden="true" data-id="element-111">
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-pink-600/20 rounded-full hero-glow" data-id="element-112" />
        <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-pink-500/15 rounded-full hero-glow" data-id="element-113" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-pink-900/10 rounded-full hero-glow" data-id="element-114" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white max-w-4xl flex flex-col items-center" data-id="element-115">
        <div className="inline-flex items-center gap-1.5 bg-pink-600/30 border border-pink-500/50 rounded-full px-3.5 py-1.5 mb-5" data-id="element-116">
          <Star className="w-3.5 h-3.5 text-pink-400 fill-pink-400" aria-hidden="true" data-id="element-117" />
          <span className="text-white font-medium text-xs tracking-wide uppercase" data-id="element-118">
            El recurso #1 para docentes de danza
          </span>
          <Star className="w-3.5 h-3.5 text-pink-400 fill-pink-400" aria-hidden="true" data-id="element-119" />
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold mb-5 leading-tight drop-shadow-lg" data-id="element-120">
          MegaPack Danza Lista: <br data-id="element-121" />
          <span className="text-pink-300 text-[28px]" data-id="element-122">
            Herramientas Completas
          </span>
        </h1>

        {/* Product Image Mockup */}
        <div className="relative w-full max-w-[240px] mx-auto mb-5" data-id="element-123">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] rounded-full opacity-40 animate-pulse-slow hero-glow" data-id="element-124" />

          <img src="https://cdn.magicpatterns.com/uploads/4QKqtVdKSUh6QnT18y4jYF/Diseno-sin-titulo-_20_.webp" alt="MegaPack Danza Lista - 6 Módulos Completos" className="relative z-10 w-full h-auto hero-product-float" loading="eager" fetchPriority="high" decoding="async" width="500" height="500" data-id="element-125" />
        </div>

        <p className="text-lg md:text-xl text-gray-200 mb-7 max-w-2xl mx-auto leading-relaxed" data-id="element-126">
          Clases listas para dar, organizadas por niveles y edades. De Baby
          Dance hasta Adultos. Transformá tus clases hoy mismo.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center w-full" data-id="element-127">
          <a href="#comprar" onClick={scrollToOffers} className="w-full sm:w-auto" data-id="element-128">
            <Button size="lg" variant="primary" className="w-full sm:w-auto text-lg px-8 py-4" data-id="element-129">
              Adquirir Ahora
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-130" />
            </Button>
          </a>
          <a href="#que-incluye" onClick={scrollToWhatIncludes} className="w-full sm:w-auto" data-id="element-131">
            <Button size="lg" variant="outline" className="w-full sm:w-auto text-lg px-8 py-4 bg-white/10 hover:bg-white/20 border-white/30" data-id="element-132">
              Más Información
            </Button>
          </a>
        </div>
      </div>
    </div>;
}